import ViewStateService from '../utils/view-state-service'
import { nextTick } from 'nandos-timing-utils'

export default {

  computed: {

    $state: {
      get() {
        return ViewStateService.getState(this.$route.path)
      },

      set(state = {}) {
        // Augment state with the page's scroll Y position
        if(!this.$el || !this.$el.querySelector) return
        let pageContent = this.$el.querySelector('.page__content')
        if(pageContent) state.scrollY = pageContent.scrollTop
        ViewStateService.saveState(this.$route.path, state)
      },
    },
  },

  methods: {

    /**
     * Example override:
     * 
     * $buildState() {
     *   return { page: 1, query: someVal }
     * },
     */
    $buildState() {},

    // A convenience method to that restores the scroll position to the root page-content element
    $restoreScrollPosition() {
      if(this.$state && this.$state.scrollY && this.$el && this.$el.querySelector) {
        let pageContent = this.$el.querySelector('.page__content')
        if(pageContent)
          nextTick(() => pageContent.scrollTop = this.$state.scrollY)
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$state = this.$buildState()
    next()
  },

  beforeRouteUpdate(to, from, next) {
    this.$state = this.$buildState()
    next()
  },
}
